import React, { useState, useEffect } from "react";
import { Col, Row, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const SubscriptionSection = (props) => {
  const [state, setState] = useState({
    /****************** Offer Management **************/
    offerManagementService: false,
    onlineOfferService: false,
    offlineOfferService: false,
    /****************** Scan And Pay **************/
    scanAndPayService: false,
    /****************** Event Management **************/
    eventMangementService: false,
    onlineEventService: false,
    offlineEventService: false,
    /****************** Live Streaming **************/
    liveStreamingService: false,
    /****************** Seating Subscription **************/
    seatingService: false,
    seatingGeneralService: false,
    seatingWalkinWaitlistService: false,
    seatingReservationService: false,
    seatingTableService: false,
    /****************** Ordering Subscription **************/
    orderingService: false,
    orderingTakeAwayService: false,
    orderingCurbSideService: false,
    orderingDineService: false,
    orderingSkipLineService: false,
    orderingAtMySeatService: false,
    orderingCateringBanquetService: false,
    orderingHomeDeliveryService: false,
    orderingMaintainBankAccountService: false,
    orderingGeneralTaxService: false,
    /***************** Menu Setup Subscription ***************/
    menuSetupService: false,
  });

  useEffect(() => {
    let activeCasualService = props?.casualDiningService;
    let activeFastFoodService = props?.fastFoodDiningService;
    let activeMultiService = props?.multiDiningService;
    let casualData = props?.casualDiningSubscription;
    let fastFoodData = props?.fastFoodSubscription;
    let multiServiceData = props?.multiServicesSubscription;

    setState({
      ...state,
      /****************** Offer Management **************/
      offerManagementService:
        (activeCasualService && casualData?.offer_management?.value) ||
        (activeFastFoodService && fastFoodData?.offer_management?.value) ||
        (activeMultiService && multiServiceData?.offer_management?.value)
          ? true
          : false,
      onlineOfferService:
        (activeCasualService &&
          casualData?.offer_management?.online_offer?.value) ||
        (activeFastFoodService &&
          fastFoodData?.offer_management?.online_offer?.value) ||
        (activeMultiService &&
          multiServiceData?.offer_management?.online_offer?.value)
          ? true
          : false,
      offlineOfferService:
        (activeCasualService && casualData?.offer_management?.offline_offer) ||
        (activeFastFoodService &&
          fastFoodData?.offer_management?.offline_offer) ||
        (activeMultiService &&
          multiServiceData?.offer_management?.offline_offer)
          ? true
          : false,
      /****************** Scan And Pay **************/
      scanAndPayService:
        (activeCasualService && casualData?.scan_and_pay?.value) ||
        (activeFastFoodService && fastFoodData?.scan_and_pay?.value) ||
        (activeMultiService && multiServiceData?.scan_and_pay?.value)
          ? true
          : false,
      /****************** Event Management **************/
      eventMangementService:
        (activeCasualService && casualData?.event_management?.value) ||
        (activeMultiService && multiServiceData?.event_management?.value)
          ? true
          : false,
      onlineEventService:
        (activeCasualService &&
          casualData?.event_management?.online_event?.value) ||
        (activeMultiService &&
          multiServiceData?.event_management?.online_event?.value)
          ? true
          : false,
      offlineEventService:
        (activeCasualService &&
          casualData?.event_management?.offline_event?.value) ||
        (activeMultiService &&
          multiServiceData?.event_management?.offline_event?.value)
          ? true
          : false,
      /****************** Live Streaming **************/
      liveStreamingService:
        (activeCasualService && casualData?.live_streaming?.value) ||
        (activeFastFoodService && fastFoodData?.live_streaming?.value) ||
        (activeMultiService && multiServiceData?.live_streaming?.value)
          ? true
          : false,
      /****************** Seating Subscription ***************/
      seatingService:
        (activeCasualService && casualData?.seating?.value) ||
        (activeMultiService && multiServiceData?.seating?.value)
          ? true
          : false,
      seatingGeneralService:
        (activeCasualService && casualData?.seating?.general_seating?.value) ||
        (activeMultiService &&
          multiServiceData?.seating?.general_seating?.value)
          ? true
          : false,
      seatingWalkinWaitlistService:
        (activeCasualService && casualData?.seating?.walkin_waitlist?.value) ||
        (activeMultiService &&
          multiServiceData?.seating?.walkin_waitlist?.value)
          ? true
          : false,
      seatingReservationService:
        (activeCasualService && casualData?.seating?.reservation?.value) ||
        (activeMultiService && multiServiceData?.seating?.reservation?.value)
          ? true
          : false,
      seatingTableService:
        (activeCasualService && casualData?.seating?.table_management?.value) ||
        (activeMultiService &&
          multiServiceData?.seating?.table_management?.value)
          ? true
          : false,
      /***************** Ordering Subscription ***************/
      orderingService:
        (activeCasualService && casualData?.ordering?.value) ||
        (activeFastFoodService && fastFoodData?.ordering?.value) ||
        (activeMultiService && multiServiceData?.ordering?.value)
          ? true
          : false,
      orderingTakeAwayService:
        (activeCasualService && casualData?.ordering?.take_away?.value) ||
        (activeFastFoodService && fastFoodData?.ordering?.take_away?.value) ||
        (activeMultiService && multiServiceData?.ordering?.take_away?.value)
          ? true
          : false,
      orderingCurbSideService:
        (activeCasualService &&
          casualData?.ordering?.cubside_delivery?.value) ||
        (activeFastFoodService &&
          fastFoodData?.ordering?.cubside_delivery?.value) ||
        (activeMultiService &&
          multiServiceData?.ordering?.cubside_delivery?.value)
          ? true
          : false,
      orderingDineService:
        (activeCasualService && casualData?.ordering?.dine_in_order?.value) ||
        (activeMultiService && multiServiceData?.ordering?.dine_in_order?.value)
          ? true
          : false,
      orderingSkipLineService:
        (activeFastFoodService && fastFoodData?.ordering?.self_serve?.value) ||
        (activeMultiService && multiServiceData?.ordering?.self_serve?.value)
          ? true
          : false,
      orderingAtMySeatService:
        (activeFastFoodService &&
          fastFoodData?.ordering?.my_seat_table_order?.value) ||
        (activeMultiService &&
          multiServiceData?.ordering?.my_seat_table_order?.value)
          ? true
          : false,
      orderingCateringBanquetService:
        (activeCasualService &&
          casualData?.ordering?.catering_banquet?.value) ||
        (activeFastFoodService &&
          fastFoodData?.ordering?.catering_banquet?.value) ||
        (activeMultiService &&
          multiServiceData?.ordering?.catering_banquet?.value)
          ? true
          : false,
      orderingHomeDeliveryService:
        (activeCasualService && casualData?.ordering?.home_delivery?.value) ||
        (activeMultiService && multiServiceData?.ordering?.home_delivery?.value)
          ? true
          : false,
      orderingMaintainBankAccountService:
        (activeCasualService &&
          casualData?.ordering?.maintain_separate_bank?.value) ||
        (activeFastFoodService &&
          fastFoodData?.ordering?.maintain_separate_bank?.value) ||
        (activeMultiService &&
          multiServiceData?.ordering?.maintain_separate_bank?.value)
          ? true
          : false,
      orderingGeneralTaxService:
        (activeCasualService && casualData?.ordering?.order_general?.value) ||
        (activeFastFoodService &&
          fastFoodData?.ordering?.order_general?.value) ||
        (activeMultiService && multiServiceData?.ordering?.order_general?.value)
          ? true
          : false,
      /***************** Menu Setup Subscription ***************/
      menuSetupService:
        (activeCasualService && casualData?.menu_setup?.value) ||
        (activeFastFoodService && fastFoodData?.menu_setup?.value) ||
        (activeMultiService && multiServiceData?.menu_setup?.value)
          ? true
          : false,
    });
  }, [
    props.casualDiningService,
    props.fastFoodDiningService,
    props.multiDiningService,
    props.casualDiningSubscription,
    props.fastFoodSubscription,
    props.multiServicesSubscription,
  ]);

  return (
    <React.Fragment>
      <Row>
        {state.liveStreamingService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Live Streaming</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink
                to={
                  state.liveStreamingService
                    ? "/edit-live-streaming"
                    : "/profile"
                }
                className="enIconBtnGraySmall"
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            <div className="f12-400">Live Streaming</div>
          </Col>
        ) : null}
        {state.offerManagementService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Offers Management</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink
                to={
                  state.offerManagementService
                    ? "/edit-offers-subscription"
                    : "/profile"
                }
                className="enIconBtnGraySmall"
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            {state.offlineOfferService ? (
              <div className="f12-400 mb-2">Offline Offers</div>
            ) : null}
            {state.onlineOfferService ? (
              <div className="f12-400">Online Offers</div>
            ) : null}
          </Col>
        ) : null}
        {state.scanAndPayService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Scan & Pay</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink
                to={
                  state.scanAndPayService
                    ? "/editscan-pay-subscription"
                    : "/profile"
                }
                className="enIconBtnGraySmall"
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            <div className="f12-400">Bank and Other Details</div>
          </Col>
        ) : null}
        {state.eventMangementService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Events Management</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink
                to={
                  state.eventMangementService
                    ? "/edit-event-subscription"
                    : "/profile"
                }
                className="enIconBtnGraySmall"
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            {state.offlineEventService ? (
              <div className="f12-400 mb-2">Offline Event</div>
            ) : null}
            {state.onlineEventService ? (
              <div className="f12-400">Online Event</div>
            ) : null}
          </Col>
        ) : null}
      </Row>
      <hr />
      <Row>
        {state.seatingService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Seating</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink
                to={
                  state.seatingService
                    ? "/edit-seating-subscription"
                    : "/profile"
                }
                className="enIconBtnGraySmall"
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            {state.seatingGeneralService ? (
              <div className="f12-400 mb-2">General Seating</div>
            ) : null}
            {state.seatingWalkinWaitlistService ? (
              <div className="f12-400 mb-2">Walk-In/Wait List</div>
            ) : null}
            {state.seatingReservationService ? (
              <div className="f12-400 mb-2">Reservations</div>
            ) : null}
            {state.seatingTableService ? (
              <div className="f12-400 mb-2">Table Management</div>
            ) : null}
          </Col>
        ) : null}
        {state.orderingService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Ordering</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink
                to={
                  state.orderingService
                    ? "/edit-ordering-subscription"
                    : // : props.fastFoodSubscription &&
                      //   props.fastFoodSubscription.ordering &&
                      //   props.fastFoodSubscription.ordering.value === true
                      // ? "/edit-ordering-fastfood-subscription"
                      // /edit-ordering-subscription
                      "/profile"
                }
                className="enIconBtnGraySmall"
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            {state.orderingTakeAwayService ? (
              <div className="f12-400 mb-2">Take Away Ordering Settings</div>
            ) : null}
            {state.orderingCurbSideService ? (
              <div className="f12-400 mb-2">Curb Side Order Settings</div>
            ) : null}
            {state.orderingDineService ? (
              <div className="f12-400 mb-2">Dine-In / Order Ahead Settings</div>
            ) : null}
            {state.orderingSkipLineService ? (
              <div className="f12-400 mb-2">
                Self Serve / SkipTheLine / Order Ahead
              </div>
            ) : null}
            {state.orderingCateringBanquetService ? (
              <div className="f12-400 mb-2">Catering / Banquet Settings</div>
            ) : null}
            {state.orderingHomeDeliveryService ? (
              <div className="f12-400 mb-2">Food Delivery Settings</div>
            ) : null}
            {state.orderingAtMySeatService ? (
              <div className="f12-400 mb-2">At My Seat or Table Order</div>
            ) : null}
            {state.orderingMaintainBankAccountService ? (
              <div className="f12-400 mb-2">
                Maintain Separate Bank Accounts For Payment & Disbursement for
                Orders
              </div>
            ) : null}
            {state.orderingGeneralTaxService ? (
              <div className="f12-400 mb-2">Order General Settings Taxes</div>
            ) : null}
          </Col>
        ) : null}
        {state.orderingService ? (
          <Col
            md={6}
            lg={3}
            xs={4}
            className="pb-4"
            style={{ borderRight: "1px solid #E0E0E0" }}
          >
            <div className="d-flex align-items-center pb-2">
              <div className="f14-700 mr-1">Menu Setup</div>
              <div className="enIconBtnGreenSmall mr-1">
                <SVG
                  src={require("../../../../assets/images/UserManagement/tick.svg")}
                />
              </div>
              <NavLink to="/menusetup-dashboard" className="enIconBtnGraySmall">
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </NavLink>
            </div>
            <div className="f12-400 mb-2">Menu Set Up</div>
          </Col>
        ) : null}
      </Row>
    </React.Fragment>
  );
};

SubscriptionSection.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  error: state.error,
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  fastFoodDiningService:
    state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  casualDiningSubscription:
    state?.onboarding &&
    state?.onboarding?.onboard_subscription_details &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status,
  fastFoodSubscription:
    state?.onboarding &&
    state?.onboarding?.onboard_subscription_details &&
    state?.onboarding?.onboard_subscription_details?.fast_food_dining_status,
  multiServicesSubscription:
    state?.onboarding &&
    state?.onboarding?.onboard_subscription_details &&
    state?.onboarding?.onboard_subscription_details
      ?.multi_service_business_status,
});

export default connect(mapStateToProps, null)(withRouter(SubscriptionSection));
